var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseNode',{attrs:{"node":_vm.node,"editor-errors":_vm.editorErrors,"title":_vm.title,"color":"#ed7d31"}},[_c('div',{staticClass:"ActionNode_text",domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }